/* eslint-disable */
// @ts-nocheck
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */

import * as Types from '../../../../../../../../api/graphql/generated';

import { api } from 'api/graphql/baseGraphqlApi';
module.hot?.accept();
export type DeletePackageGroupMutationVariables = Types.Exact<{
  input: Types.MutatePackageGroupInput;
}>;


export type DeletePackageGroupMutation = { __typename?: 'Mutation', deletePackageGroup?: { __typename?: 'PackageGroup', id: string } | null };


export const DeletePackageGroupDocument = `
    mutation deletePackageGroup($input: MutatePackageGroupInput!) {
  deletePackageGroup(input: $input) {
    id
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (build) => ({
    deletePackageGroup: build.mutation<DeletePackageGroupMutation, DeletePackageGroupMutationVariables>({
      query: (variables) => ({ document: DeletePackageGroupDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useDeletePackageGroupMutation } = injectedRtkApi;

